import React, { useEffect, useMemo, useState } from 'react';
import {  FaUsers, FaFileAlt, FaCog, FaClock, FaArrowRight, FaCoins  } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../components/Config/api.service';
import { AiOutlineMan, AiOutlineWoman  } from "react-icons/ai";
import FullCalendar from '@fullcalendar/react'; 
import MyCalendar from '../Calendar/MyCalendar';
import dayGridPlugin from '@fullcalendar/daygrid'; 
import interactionPlugin from '@fullcalendar/interaction';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend);
function Home() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    totalEmployees: 0,
    maleEmployees: 0,
    femaleEmployees: 0,
    currentAbsences: 0,
    totalPayrollCost: 0,
    total_brut: 0,
    total_salariale_globale_prev_month: 0,
    total_impots: 0,
    total_cotisation_salariale: 0,
    total_cotisation_patronale: 0,
  });
  const [selectedDates, setSelectedDates] = useState([
  {
    title: "Fête Nationale",
    start: new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0],
    color: "#0f172a" 
  },
  {
    title: "Event 2",
    start: new Date(new Date().setDate(new Date().getDate() + 3)).toISOString().split('T')[0],
    color: "#eab308" 
  },
  {
    title: "Declaration",
    start: new Date(new Date().setDate(new Date().getDate() + 5)).toISOString().split('T')[0],
    color: "#f97316" 
   },
  // {
  //   title: "Event 4",
  //   start: new Date(new Date().setDate(new Date().getDate() + 7)).toISOString().split('T')[0],
  //   color: "#3b82f6"
  // }
]);

  // Memoize date-related calculations
  const dateInfo = useMemo(() => {
    const today = new Date();
  // Helper function to capitalize first letter
  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
      
  // Get month names and capitalize them
  const currentMonth = capitalize(today.toLocaleDateString('fr-FR', { month: 'long' }));
  

    const fullDate = today.toLocaleDateString('fr-FR', { 
      weekday: 'long', 
      day: 'numeric', 
      month: 'long', 
      year: 'numeric' 
    });
    
    // Calculate next month properly
    const nextMonthIndex = today.getMonth() === 11 ? 0 : today.getMonth() + 1;
    const nextMonthYear = today.getMonth() === 11 ? today.getFullYear() + 1 : today.getFullYear();
    const nextMonth = new Date(nextMonthYear, nextMonthIndex, 1).toLocaleDateString('fr-FR', { month: 'long' });
    
    // Calculate days until closure
    const nextFifth = new Date(nextMonthYear, nextMonthIndex, 5);
    const diffTime = nextFifth - today;
    const daysUntilClosure = Math.max(0, Math.ceil(diffTime / (1000 * 60 * 60 * 24)));
    const daysInMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
    return {
      currentMonth,
      fullDate,
      nextMonth,
      daysUntilClosure,
      daysInMonth
    };
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
  };

  const data = {
    labels: ['Salaire Versé', 'Charges Patronales', 'Charges Salariales'],
    datasets: [
      {
        label: 'Répartition',
        data: [stats.totalPayrollCost, stats.total_cotisation_patronale, stats.total_cotisation_salariale],
        backgroundColor: ['#FFB3B3', '#A5F0C5', '#FFEB85'],
        borderWidth: 1,
      },
    ],
  };

  useEffect(() => {
    apiService.getElement('/dashboard_stats')
    .then((response) => {
      console.log('Stats fetched successfully:', response.data.dashboard_stats);
      const { totalEmployees, maleEmployees, femaleEmployees, currentAbsences, totalPayrollCost,
         total_brut, total_salariale_globale_prev_month, total_impots, total_cotisation_salariale, total_cotisation_patronale  } = response.data.dashboard_stats;
      setStats({
        totalEmployees,
        maleEmployees,
        femaleEmployees,
        currentAbsences,
        totalPayrollCost,
        total_brut,
        total_salariale_globale_prev_month,
        total_impots,
        total_cotisation_salariale,
        total_cotisation_patronale
      });
    }
    )
    .catch((error) => {
      console.error('Error fetching stats:', error);
    });
  }
  , []);

  const calculateTotalCost = () => {
    return (
      parseFloat(stats.totalPayrollCost || 0) +
      parseFloat(stats.total_cotisation_salariale || 0) +
      parseFloat(stats.total_cotisation_patronale || 0)
    );
  };

  const claculateDelta = () => {
    const currentCost = calculateTotalCost();
    const previousCost = parseFloat(stats.total_salariale_globale_prev_month || 0);
    const delta = previousCost ? ((currentCost - previousCost) / previousCost) * 100 : 0;
    return delta.toFixed(2);
  };

  return (
    <div className="">
      <div className="mx-auto px-2 ">
        
        <header>
          <h1 className="text-4xl font-bold">Bienvenue</h1>
          <p className="text-gray-600 mb-6">{`Nous sommes le ${dateInfo.fullDate}`}</p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
          {/* Section principale */}
          <div className="md:col-span-9 gap-4">
            <div className="bg-white rounded-lg shadow-md px-6 py-3 mb-6">
              <div className="flex justify-between items-center mb-8">
                <h2 className="text-2xl font-bold">Votre Paie de {dateInfo.currentMonth}</h2>
                <div className="flex items-center gap-4">
                  <div className="flex items-center">
                    <span className="inline-block mr-2" aria-hidden="true">
                      <FaClock size={20} />
                    </span>
                    <span className="text-gray-600">Cloture dans</span>
                    <span className="font-semibold ml-2">
                      {dateInfo.daysUntilClosure} jours
                    </span>
                  </div>
                  <button
                    onClick={() => handleNavigate("/payslip/report")}
                    className="bg-[--color-primary] text-white px-4 py-2 rounded-full flex items-center">
                    Gérer la paie
                    <FaArrowRight className="ml-2" size={14} aria-hidden="true" />
                  </button>
                </div>
              </div>

              <div className="bg-gray-200 rounded-full h-2 mb-4">
                <div
                  className="bg-[--color-primary] h-2 rounded-full"
                  style={{ width: `${(dateInfo.daysInMonth + 5 - dateInfo.daysUntilClosure) / (dateInfo.daysInMonth+5) * 100}%` }}
                ></div>
              </div>

              {/* Étapes de la paie */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="flex gap-4">
                  <div className="flex flex-col items-baseline mb-1">
                    <span className="text-xl font-bold mr-2">5</span>
                    <span className="text-gray-500 text-sm">{dateInfo.currentMonth}</span>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Ouverture de la paie</h3>
                    <p className="text-gray-500 text-sm">Début de la période de {dateInfo.currentMonth}</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="flex flex-col items-baseline mb-1">
                    <span className="text-xl font-bold mr-2">15</span>
                    <span className="text-gray-500 text-sm">{dateInfo.currentMonth}</span>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Préparation des bulletins</h3>
                    <p className="text-gray-500 text-sm">Vérification des variables de paie</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="flex flex-col items-baseline mb-1">
                    <span className="text-xl font-bold mr-2">5</span>
                    <span className="text-gray-500 text-sm">{dateInfo.nextMonth}</span>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Cloture de la paie</h3>
                    <p className="text-gray-500 text-sm">Préparation des salaires</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Statistiques */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <div className="bg-white rounded-lg p-3 space-y-2 pb-2">
                <p className="text-3xl font-bold">{stats.totalEmployees}</p>
                <p className="font-bold text-[--color-primary]">Collaborateurs</p>
                <div className="flex items-center gap-2">
                  <div className="p-1 bg-[#FFEB85] rounded-lg">
                    <AiOutlineWoman size={20} className="text-[--color-primary]" aria-hidden="true" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">{stats.femaleEmployees}</p>
                    <p className="text-sm font-semibold text-[--color-primary]">Femmes</p>
                  </div>
                  <div className="p-1 bg-[#C9FFFB] rounded-lg">
                    <AiOutlineMan size={20} className="text-[--color-primary]" aria-hidden="true" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">{stats.maleEmployees}</p>
                    <p className="text-sm font-semibold text-[--color-primary]">Hommes</p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-lg p-3 space-y-2">
                <p className="text-3xl font-bold">{stats.currentAbsences}</p>
                <p className="font-bold text-[--color-primary]">Absents</p>
                <div className="flex items-center justify-between">
                  <p className="text-sm text-gray-500">Taux d'absence</p>
                  <span className="bg-[#28C76F29] text-[--color-primary] px-2 py-1 rounded-lg text-sm font-semibold">{((stats.currentAbsences / stats.totalEmployees) * 100).toFixed()}%</span>
                </div>
              </div>
              <div className="rounded-lg p-3 bg-gradient-to-b from-[#FFFCEA] to-[#FFFFFF] space-y-2">
                <div className="flex justify-end">
                  <p className="text-sm text-[--color-primary] font-bold">{claculateDelta()}%</p>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-start gap-2">
                    <p className="text-3xl text-[--color-primary] font-bold">
                      {calculateTotalCost().toLocaleString('fr-FR')}
                    </p>     
                    <span className="text-[--color-primary] text-sm">FCfa</span>
                  </div>
                </div>
                <p className="font-bold text-[--color-primary]">Cout salarial global</p>
                <p className="text-sm text-gray-500">Mois dernier: {stats.total_salariale_globale_prev_month.toLocaleString('fr-FR')}</p>
              </div>
            </div>

            {/* Graphique et repartition */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-white col-span-2 rounded-lg p-6 shadow-md">
                <h3 className="font-bold text-center text-xl mb-8">Répartition des charges</h3>
                <div className='flex items-center gap-4'>
                  <div className="w-1/2 h-64 flex flex-col items-center justify-center relative">
                    <Doughnut
                      data={data}
                      options={{
                        maintainAspectRatio: false,
                        plugins: {
                          legend: {
                            display: false, // Désactiver les légendes générées automatiquement
                          },
                        },
                      }}
                    />
                    
                  </div>
                  {/* Légendes personnalisées avec montants */}
                  <div className="flex flex-col gap-6">
                    {/* Affichage de la somme totale sous le cercle */}
                    <div className="text-center w-full">
                      <span className="font-bold text-lg text-gray-700">
                        Total : {
                          data.datasets[0].data
                            .map(val => Number(val) || 0)
                            .reduce((a, b) => a + b, 0)
                            .toLocaleString('fr-FR')
                        } Fcfa
                      </span>
                    </div>
                    {data.labels.map((label, index) => (
                      <div key={index} className="flex items-center gap-2">
                        <span
                          className="w-4 h-4 rounded-full"
                          style={{ backgroundColor: data.datasets[0].backgroundColor[index] }}
                        ></span>
                        <span className=" text-gray-600">{label}</span>
                        <span className=" font-semibold text-gray-800">
                          {(Number(data.datasets[0].data[index]) || 0).toLocaleString('fr-FR')} Fcfa
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-md">
                <h3 className="font-bold text-xl mb-16">Répartition des salaires</h3>
                <div className=" text-gray-600 space-y-4">
                  <p className="flex justify-between">
                    Total brut : <span className="font-bold text-gray-800">{stats.total_brut.toLocaleString('fr-FR')} Fcfa</span>
                  </p>
                  <p className="flex justify-between items-center">
                    <span>
                      Total Cotisation<br />Salariale&nbsp;:
                    </span>
                    <span className="font-bold text-gray-800 break-all">{stats.total_cotisation_salariale.toLocaleString('fr-FR')} Fcfa</span>
                  </p>
                  <p className="flex justify-between items-center">
                    <span>
                      Total Cotisation<br />Patronale&nbsp;:
                    </span>
                    <span className="font-bold text-gray-800 break-all">{stats.total_cotisation_patronale.toLocaleString('fr-FR')} Fcfa</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="md:col-span-3 flex flex-col h-full">
            {/* Calendrier */}
            <div className="bg-white p-1 rounded-lg max-h-[350px] overflow-hidden">
              {/* <FullCalendar
                plugins={[dayGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                locale="fr"
                firstDay={1}
                headerToolbar={{
                  start: 'prev',
                  center: 'title',
                  end: 'next',
                }}
                selectable={true}
                events={selectedDates} 
                height={"auto"}
                contentHeight={"auto"}
              /> */}
              <MyCalendar />
            </div>
            <div className="bg-white rounded-lg p-6 mt-8 flex-1 flex flex-col justify-between">
              <h3 className="text-xl text-center mb-12 font-bold">Évènements à venir</h3>
              <div className="space-y-3 flex-1">
                {selectedDates.map((event, index) => (
                  <div key={index} className="flex justify-between items-center bg-gray-100 p-4 rounded-lg">
                    <div className="flex items-start space-x-3">
                      <div className="w-1.5 h-5 rounded" style={{ backgroundColor: event.color }}></div>
                      <div>
                        <p className="font-semibold text-slate-800">{event.title}</p>
                      </div>
                    </div>
                    <p className="text-sm text-gray-400">{event.start}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Accès rapides */}
        <div className=" pt-8 mb-8">
          <h2 className="text-2xl font-bold mb-4">Vos accès rapides</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div 
              className="bg-white rounded-lg p-6 cursor-pointer border border-[--color-primary]"
              onClick={() => handleNavigate("/primes")}
            >
              <div className="flex items-center gap-4 mb-4">
                <FaCoins  size={20} className="text-[--color-primary]" aria-hidden="true" />
                <h3 className="font-bold text-[--color-primary]">Elements de remuneration</h3>
              </div>
              
              <p className="text-sm text-gray-600">Gérez vos primes, avantages et déductions</p>
              
              <div className="flex bg-[--bg-color] justify-center p-1 w-[100px] items-center gap-2 mt-4 text-[--color-orange] text-sm font-semibold">
                <a>Voir plus</a>
                <FaArrowRight/>
              </div>
            </div>
            
            <div 
              className="bg-white rounded-lg p-6 cursor-pointer border border-[--color-primary]"
              onClick={() => handleNavigate("/payslip/report")}
            >
              <div className="flex items-center gap-4 mb-4">
                <FaFileAlt size={20} className="text-[--color-primary]" aria-hidden="true" />
                <h3 className="font-bold text-[--color-primary]">Bulletin de paie</h3>
              </div>
              <p className="text-sm text-gray-600">Retrouvez tous les bulletins du mois</p>
              <div className="flex bg-[--bg-color] justify-center p-1 w-[100px] items-center gap-2 mt-4 text-[--color-orange] text-sm font-semibold">
                <a>Voir plus</a>
                <FaArrowRight/>
              </div>
            </div>
            
            <div 
              className="bg-white rounded-lg p-6 cursor-pointer border border-[--color-primary]"
              onClick={() => handleNavigate("/employees")}
            >
              <div className="flex items-center gap-4 mb-4">
                <FaUsers size={20} className="text-[--color-primary]" aria-hidden="true" />
                <h3 className="font-bold text-[--color-primary]">Mes collaborateurs</h3>
              </div>
              <p className="text-sm text-gray-600">Afficher tous vos collaborateurs</p>
              <div className="flex bg-[--bg-color] justify-center p-1 w-[100px] items-center gap-2 mt-4 text-[--color-orange] text-sm font-semibold">
                <a>Voir plus</a>
                <FaArrowRight/>
              </div>
            </div>
            
            <div 
              className="bg-white rounded-lg p-6 cursor-pointer border border-[--color-primary]"
              onClick={() => handleNavigate("/settings")}
            >
              <div className='flex items-center gap-4 mb-4'>
                <FaCog size={20} className="text-[--color-primary]" aria-hidden="true" />
                <h3 className="font-bold text-[--color-primary]">Paramètres</h3>
              </div>
              <p className="text-sm text-gray-600">Ajuster vos règles de gestion de la paie</p>
              <div className="flex bg-[--bg-color] justify-center p-1 w-[100px] items-center gap-2 mt-4 text-[--color-orange] text-sm font-semibold">
                <a>Voir plus</a>
                <FaArrowRight/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;